// ==============================|| OVERRIDES - TABS ||============================== //

export default function AppBar(theme) {
    return {
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: `#66308C`,
                    color: `${theme.palette.menuMain.contrastText} !important`
                }
            }
        }
    };
}
